<template>
    <div>
        <h4>The page you are looking is invalid ! </h4>
    </div>
</template>
<script>
export default {
    name : "NotFound"
}
</script>